module.exports = __webpack_public_path__ + "img/heart.1.741d12d.svg";